import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { listUserExports } from "../../api/exports/listUserExports";
import ExportsTable from "../../components/Exports/ExportsTable";
import { useErrorHandler } from "../../hooks/Error/useErrorHandler";
import { setLoading } from "../../store/UI";
import { ExportRow } from "../../types/model/export/ExportRow";

const ListExports = () => {
  const dispatch = useDispatch();
  const handleError = useErrorHandler();

  const [exports, setExports] = React.useState<ExportRow[]>([]);

  const refreshData = async () => {
    dispatch(setLoading(true));

    try {
      const response = await listUserExports();
      setExports(response);
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <ExportsTable
      tableData={exports}
      onRequestRefresh={refreshData}
    />
  );
};

export default ListExports;